export const Roles = {
    Administrator: 'Administrator',
    Klub: 'Klub',
    Sodnik: 'Sodnik',
}
